import React from 'react';

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */
export var CarouselContext = /*#__PURE__*/React.createContext({});